<template>
  <div class="client-item-box j_client_item" v-if="dataLoaded" :data-trackdata="tData">
    <div class="image-index-box" @click="imageAction">
      <beast-image class="img" v-if="containerWidth"
        :lazy="true"
        :image="data.image"
        :containerWidth="containerWidth"
      />
      <div v-if="blockColor" class="block-box" :style="{'background': blockColor}"></div>
      <div class="text-box">
        <p class="text-item" v-for="item in items" :style="{'color': item.textColor}">{{item.text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'

import beastImage from '@/components/image'

const clientWidth = getClientWidth()

export default {
  name: 'image-index',
  // props: ['data'],
  props: ['data', 'memberTags', 'isApp'],
  components: {
    beastImage
  },
  data () {
    return {
      dataLoaded: false,
      containerWidth: clientWidth,
      items: [],
      blockColor: null,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted() {
  },
  computed: {
  },
  created() {
    this.checkMember()
  },
  methods: {
    checkMember () {
      const tags = this.memberTags || []
      if(!tags.length || this.data.customer === 'ALL') {
        this.dataLoaded = true
      } else if(tags.indexOf(this.data.customer) !== -1) {
        this.dataLoaded = true
      } else if(this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) !== -1) {
        this.dataLoaded = true
      }
      // if(this.member === 'OLD') {
      //   if(this.data.customer !== 'NEW') {
      //     this.dataLoaded = true
      //   }
      // } else if(this.member === 'NEW') {
      //   if(this.data.customer !== 'OLD') {
      //     this.dataLoaded = true
      //   }
      // } else {
      //   this.dataLoaded = true
      // }

      console.log(this.dataLoaded, "dataLoaded")

      if(this.dataLoaded) {
        this.formatData()
      }
    },
    formatData () {
      let items = this.data.items
      let newItems = []
      items.forEach((item) => {
        item.text && newItems.push(item)
      })
      console.log(newItems, "newItems")
      this.blockColor = newItems[0]?newItems[0].textColor:''
      this.items = newItems
    },
    imageAction () {
      this.skipLink(this.data.link, this.data.title)
    },
    skipLink (link, title) {
      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && this.data.toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link,
                title
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link,
                title
              })
      }

      trackAction({
        trackData: this.data.trackData,
        pageObj: getLinkPageData({link, title})
      })

      normalSkip({
        // trackData: {
        //   name: 'image-index',
        //   attrs: {
        //     index: this.imageIndex,
        //     trackTitle: this.data.trackTitle
        //   },
        //   wait: false
        // },
        link: myLink,
        toMiniProgram: toMiniFlag
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// image-index.vue?7cb7af26